import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledWidgetHero = styled.section`
  text-align: center;
  background: #fff;
  padding: 10px 0px 50px;

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 20px 0px 50px;
  }

  header.fix-position {
    background: transparent;
    box-shadow: none;
    padding: 0 0 15px;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0;
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
    top: 0;
    left: 0;

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px 15px;
    }
  }

  .navbar-wrapper {
    max-width: 1320px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 3;

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px;
    }

    nav.fixed {
      top: 0;
      background-color: ${CSSVars.white};
      border-bottom: 1px solid #e0e0e0;

      .links {
        background-color: ${CSSVars.white};
        box-shadow: none;
        border-radius: 0;
        border: none;
        padding: 10px 0;

        .logo,
        ul a {
          color: ${CSSVars.black};
        }

        .cta-li a {
          background-color: ${CSSVars.blue500};
          color: ${CSSVars.white};
          border: none;

          &:hover {
            background-color: ${CSSVars.blue600};
          }
        }
      }
    }

    nav:not(.fixed) {
      .links {
        display: flex;
        gap: 20px;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          justify-content: center;
        }

        .logo,
        ul a {
          color: ${CSSVars.black};
        }
      }
    }
  }

  .hero-wrapper {
    position: relative;
    color: ${CSSVars.black};
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    align-items: center;
    text-align: center;
    max-width: 1320px;
    margin: 0 auto;
		padding: 100px 0 40px;
    width: 100%;

    @media screen and (max-width: ${CSSVars.breakpointMD}) {
      flex-direction: column;
      justify-content: flex-start;
    }

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px;
    }
		
		.widget-editor-img {
			position: absolute;
			top: 65%;
			left: 50%;
			z-index: 0;
			transform: translate(-50%, -50%);
			opacity: 0.25;
		}
  }

  div.hero-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    position: relative;
    z-index: 1;

    @media screen and (max-width: ${CSSVars.breakpointXL}) {
      padding: 0 20px;
    }

    @media screen and (max-width: ${CSSVars.breakpointMD}) {
      justify-content: center;
      text-align: center;
      margin-top: 20px;
    }

    .hero-platform-logo {
      position: relative;
      margin-bottom: 20px;

      img {
        height: 40px !important;
        width: auto !important;
        position: relative !important;
      }
    }

    h1 {
      max-width: 100%;
      font-size: ${CSSVars.fontSize2XL};
      line-height: 1.4;
      margin: 0;
      padding: 0;
      font-weight: 600;
      max-width: 600px;
    }

    h2 {
      font-size: ${CSSVars.fontSizeLG};
      max-width: 100%;
      font-weight: 300;
      margin: 0;
      padding: 0;
      max-width: 600px;
    }

    div.button-wrapper {
      margin: 40px 0 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: 0;

      @media screen and (max-width: ${CSSVars.breakpointMD}) {
        justify-content: center;
        text-align: center;
        margin-top: 20px;
      }

      > a {
        margin: 20px 0;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          margin: 20px auto;
        }
      }

      .rating-wrapper {
        margin: 20px 0 0;

        @media screen and (max-width: ${CSSVars.breakpointMD}) {
          margin: 20px auto 0;
        }

        .rating {
          > svg path {
            fill: #ffca46;
          }

          p {
            color: ${CSSVars.black};
          }
        }
      }

      @media screen and (min-width: ${CSSVars.breakpointSM}) {
        /* align-items: flex-start; */
      }

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        font-size: ${CSSVars.fontSizeXL};
      }
    }
  }

	.no-templates-wrapper {
		color: ${CSSVars.black};
		background-color: ${CSSVars.white};
		font-size: ${CSSVars.fontSizeMD};
		padding: 40px;
		border-radius: 10px;
		margin: 0 auto 40px;
		max-width: 600px;
		text-align: center;
		border: 1px solid ${CSSVars.gray100};
    position: relative;
    z-index: 1;

		p {
			margin: 0 0 10px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.start-with-blank-wrapper {
			margin-top: 20px;
			text-align: center;

			> a {
				margin: 0 auto;
			}
		}
	}
`;
